import { FC, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { TabView, TabPanel } from 'primereact/tabview';
import './scenarioplan.css'

import { FiltersModal } from "./FiltersModal/FiltersModal";
import { InputText } from 'primereact/inputtext';
import { HiOutlineIdentification } from 'react-icons/hi'
import { IFilterScenario, IScenario, ISimulacion, ISimulationComparision } from "../../models/ScenarioModel";
import { error, warning } from "../../utils/notifications";
import {  getSimulationComparisionByTabID } from "../../services/scenario-service";
import { BsFillSendCheckFill } from "react-icons/bs";
import { FaExchangeAlt, FaTruckMoving } from "react-icons/fa";
import { catchResponse, dateFormatter, defaultRenderer, getMonthInterval, numberFormatter } from "../../utils/helperFunctions";
import { Badge } from 'primereact/badge';
import { Tooltip } from "primereact/tooltip";
import { SpeedDial } from "primereact/speeddial";
import { AiFillFilter } from "react-icons/ai";
import { ScenarioSelector } from "../Scenario/ScenarioSelector/ScenarioSelector";
import { EntregasLayout } from "./EntregasLayout/EntregasLayout";
import { ProveedoresInternosLayout } from "./ProveedoresInternosLayout/ProveedoresInternosLayout";
import { ProveedoresExternosLayout } from "./ProveedoresExternosLayout/ProveedoresExternosLayout";
import { TransporteLayout } from "./TransporteLayout/TransporteLayout";
import { FcExternal, FcInternal } from "react-icons/fc";
import { FiCommand } from "react-icons/fi";
import { STATE_ENTREGAS_INITIAL_STATE, STATE_EXTERNAL_PROVIDERS_DONUT, STATE_EXTERNAL_PROVIDERS_ENTRADAS_STATE, STATE_INTERNAL_PROVIDERS_ENTRADAS_STATE_REF, STATE_INTERNAL_PROVIDERS_ENTRADA_INVENTARIO_STATE, STATE_INTERNAL_PROVIDERS_NAVES_RANK_STATE, STATE_INTERNAL_PROVIDERS_WAREHOUSE_RANK_STATE, STATE_TRANSPORTE } from "../../data/constants";
import { MdInventory, MdOutlineChevronLeft, MdOutlineChevronRight } from "react-icons/md";

import { Help } from "./Help/Help";
import { Dialog } from "primereact/dialog";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { getAllScenarios } from "../../services/home-service";

export const Menu:FC<any> = (props):JSX.Element => {

    const {tabID,comparativa,filtersUsedCounter} = props

    const [isOpen, setIsOpen] = useState(true);
    
    const [showTitle, setShowTitle] = useState<boolean>(false)


    const handleRenderTitle = () => {
        if(isOpen === true) {
            setIsOpen(!isOpen)
            setTimeout(() => {
                setShowTitle(true);
            }, 300);
        } else {
            setIsOpen(!isOpen)
            setShowTitle(false); 
        }
        
    };

    const renderHelp = () => {
        if(!isOpen) {
            switch(tabID) {
                case 1:
                    return (
                        <Help
                            comparativa={comparativa}
                            kpis={[
                                'Entrada (Tm): Número total de toneladas que entran en planta.',
                                'Nº Órdenes: Número total de entradas que planificamos a planta.',
                                'Coste(€): Coste total del material, kilómetros recorridos y pérdidas que entran en planta.',
                                '** No aplica filtro temporal'
                            ]}
                            tabID={tabID}
                            filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                            />
                    )
                case 2:
                    return (
                        <Help
                            comparativa={comparativa}
                            kpis={[
                                'Recepcionado (Tm):  Cantidad total de biomasa recepcionada de los acopios propios.',
                                'Contratado (Tm):  Cantidad total de biomasa contratada de los acopios propios.',
                                'Desviación (Tm): Diferencia entre ambos.',
                                '** No aplica filtro temporal'
                            ]}
                            tabID={tabID}
                            filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                            />
                    )
                    
                case 3:
                    return (
                        <Help
                            comparativa={comparativa}
                            kpis={[
                                'Peso Neto (Tm):  Peso total de la biomasa consumida mandada por lo acopios.',
                                'Coste Compra (€): Coste total de la biomasa recibida.',
                                '** No aplica filtro temporal'
                            ]}
                            tabID={tabID}
                            filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                            />
                    )
                   
                        
                case 4:
                    return (
                        <Help
                            comparativa={comparativa}
                            kpis={[
                                'Número de Orígenes:  Cantidad total de acopios que mandan biomasa dentro de la planificación.',
                                'Peso Neto (Tm):  Peso total de la biomasa consumida mandada por lo acopios.',
                                'Peso Contratado (Tm): Cantidad total de los pedidos que han hecho a proveedores externos.',
                                'Desviación (€): Diferencia entre Peso Neto y Peso Contratado.',
                                '** No aplica filtro temporal'
                            ]}
                            tabID={tabID}
                            filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                        />
                    )
                    

                case 5:
                    return (
                        <Help
                            comparativa={comparativa}
                            kpis={[
                                'Distancia Media (Km):  Distancia media recorrida por proveedor.',
                                'Distancia Total (Km):  Distancia total recorrida por los transportistas.',
                                'Coste Total (€): Coste total del transporte.',
                                'Peso Total de las Pérdidas (Tm): Peso total de las pérdidas.',
                                'Coste Total de las Pérdidas (€): Coste total de las perdidas.',
                                '** No aplica filtro temporal'
                            ]}
                            tabID={tabID}
                            filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                        />
                    )
                    
                    
                default:
                    return (
                        <div style={{height:'100%',width:'80%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                            Cargando...
                        </div>
                    )
            }
        } else {
            return false
        }
        
    }

    return (
        <div className={`sidebar ${isOpen ? '' : 'sidebar-closed'}`}>
        <button className={"sidebar__button"} onClick={handleRenderTitle}>
          {
            !isOpen?
            <MdOutlineChevronRight size={20} style={{cursor:'pointer'}} />
            :
            <MdOutlineChevronLeft size={20} style={{cursor:'pointer'}} />
          }
          {
            !isOpen && showTitle &&
                <span style={{marginLeft:'0.6rem',fontWeight:'bold',borderBottom:'1px solid lightgray'}}>Interpretación de resultados</span>
            }
        </button>
        <div style={{height:405,display:'flex',justifyContent:'center',alignItems:'center'}}>
            
                {renderHelp()}
                
               
          </div>
        
      </div>
    );
  };

export const ScenarioPlan:FC<any> = (props):JSX.Element => {

    const { history } = props

    const [comparativa, setComparativa] = useState<boolean>(history?.location?.state?.comparativa ?? false)

    const [ entradas, setEntradas ] = useState<boolean>(true)

    const [stateEntregas, setStateEntregas] = useState<any>(STATE_ENTREGAS_INITIAL_STATE)

    const [kpisEntregas, setKpisEntregas] = useState<any[]>([])

    const [stateInventario, setStateInventario] = useState<any>(STATE_INTERNAL_PROVIDERS_ENTRADA_INVENTARIO_STATE)

    const [stateWarehouseRank, setStateWarehouseRank] = useState<any>(STATE_INTERNAL_PROVIDERS_WAREHOUSE_RANK_STATE)

    const [stateNavesRank, setStateNavesRank] = useState<any>(STATE_INTERNAL_PROVIDERS_NAVES_RANK_STATE)

    const [kpisEntradas, setKpisEntradas] = useState<any[]>([])

    const [kpisSalidas, setKpisSalidas] = useState<any[]>([])

    const [kpisProveedoresExternos, setKpisProveedoresExternos] = useState<any[]>([])

    const [stateDonutExternos, setStateDonutExternos] = useState<any>(STATE_EXTERNAL_PROVIDERS_DONUT)

    const [stateDonutInternos, setStateDonutInternos] = useState<any>(STATE_EXTERNAL_PROVIDERS_DONUT)

    const [stateEntradasProveedorExterno, setStateEntradasProveedorExterno] = useState<any>(STATE_EXTERNAL_PROVIDERS_ENTRADAS_STATE)

    const [stateEntradasProveedorInterno, setStateEntradasProveedorInterno] = useState<any>(STATE_INTERNAL_PROVIDERS_ENTRADAS_STATE_REF)

    const [stateTransporte, setStateTransporte] = useState<any>(STATE_TRANSPORTE)

    const [kpisTransporte, setKpisTransporte] = useState<any[]>([])

    const [visible, setVisible] = useState<boolean>(false)

    const [currentTooltip, setCurrentTooltip] = useState<any[]>([])

    const [currentSerie, setCurrentSerie] = useState<any>({color: '',month:''})

    const [allScenarios, setAllScenarios] = useState<any[]>([])

    const handleCloseTooltipModal = () => {
        setVisible(false)
        setCurrentTooltip([])
    }


    const INITIAL_STATE_SCENARIO:IScenario = {
        id_scenario: 1,
        name_scenario: "",
        id_plant: 1,
        name_plant: "",
        id_planner: 1,
        name_planner: "",
        campaign:[22,23],
        settings: {
            provider : {
                provider_table: [],
                contract_table: []
            },
            warehouse : {
                provider_table: [],
                warehouse_table: []
            },
            shipping : {
                shipping_km_table : [],
                shipping_month_table : [],
                shipping_plant_table: []
            },
            precipitation: {
                precipitation_map: {},
                precipitation_table: []
            },
            energy_consumption:[]
        }
    }

    

    const INITIAL_FILTER_STATE:IFilterScenario = {
        warehouse :"",
        transport: "",
        month_from: "",
        month_to: "",
        own_foreign:""

    }

   


    const [scenarioBase, setScenarioBase] = useState<IScenario>(INITIAL_STATE_SCENARIO)

    const [scenarioComparision, setScenarioComparision] = useState<IScenario>(INITIAL_STATE_SCENARIO)

    const [loadingScenarioComparision, setLoadingScenarioComparision] = useState<boolean>(false)


    const [filters, setFilters] = useState<IFilterScenario>(INITIAL_FILTER_STATE)

    const [filtersMASTER, setFiltersMASTER] = useState<IFilterScenario>(INITIAL_FILTER_STATE)

   
    const [filtersUsedCounter, setFiltersUsedCounter] = useState<number[]>([0,0,0,0,0])

    const [openFiltersModal, setOpenFiltersModal] = useState<boolean>(false)


    const [flagChangeScenario, setFlagChangeScenario] = useState<boolean>(true)

    
    const handleOpenFiltersModal = () => {
        setOpenFiltersModal(true)
    }


   
    const {id,id_compare}:any = useParams()

    const [scenarioToCompare, setScenarioToCompare] = useState<number>(id)

    const [tabID, setTabID] = useState<number>(1)

    const [loadingTab, setLoadingTab] = useState<boolean>(false)

    const handleTabID = (e:any) => {
        const { innerText } = e.target

        switch(innerText) {
            case 'Entregas':
                setTabID(1)
                break;
            case 'Stocks iniciales':
                setTabID(2)
                break;
            case 'Proveedores internos':
                setTabID(3)
                break;
            case 'Proveedores externos':
                setTabID(4)
                break;
            case 'Transporte':
                setTabID(5)
                break;
            default:
                
        }
       
        
    }

    const testFunction = (event:any, chartContext:any, config:any) => {
        
            let {dataPointIndex,seriesIndex} = config
            let {series} = config.w.config 
            let {categories} = config.w.config.xaxis

            let data = series[seriesIndex].aux

            let aux = data[dataPointIndex] 

            if(aux.length > 27*3) {
                setCurrentSerie({color:seriesIndex === 0? 'var(--lis-dark)' : 'var(--lis-alternative)',month:categories[dataPointIndex]})
                setCurrentTooltip(aux)
                setVisible(true)
            }
          
    }

    const emptyData = () => {

        if(tabID !== 1) {
            setKpisEntregas([])
            setStateEntregas(STATE_ENTREGAS_INITIAL_STATE)
        }
        
        if(tabID !==2) {
            setStateWarehouseRank(STATE_INTERNAL_PROVIDERS_WAREHOUSE_RANK_STATE)
            setStateNavesRank(STATE_INTERNAL_PROVIDERS_NAVES_RANK_STATE)
            setStateInventario(STATE_INTERNAL_PROVIDERS_ENTRADA_INVENTARIO_STATE)
            setKpisEntradas([])
               
        }

        if(tabID !==3) {
            
            setKpisSalidas([])
            setStateDonutInternos(STATE_EXTERNAL_PROVIDERS_DONUT)
            setStateEntradasProveedorInterno(STATE_INTERNAL_PROVIDERS_ENTRADAS_STATE_REF)   
        }
        
        if(tabID !== 4) {
            setKpisProveedoresExternos([])
            setStateDonutExternos(STATE_EXTERNAL_PROVIDERS_DONUT)
            setStateEntradasProveedorExterno(STATE_EXTERNAL_PROVIDERS_ENTRADAS_STATE)
        }
        
        if(tabID !== 5) {
            setKpisTransporte([])
            setStateTransporte(STATE_TRANSPORTE)
        }
   
    }

    const items = [
        {
            label: 'Filtros',
            icon: filtersUsedCounter.filter((filt:any) => filt !== 0).length === 0? <AiFillFilter size={18}/> : <Badge value={filtersUsedCounter.filter((filt:any) => filt !== 0).length}><AiFillFilter size={18}/></Badge>,
            command: (e:any) => {
                handleOpenFiltersModal()
                //e.preventDefault()
            },
        },
        {
            label: 'Ver escenario',
            icon: 'pi pi-external-link',
            command: () => history.push({
                pathname: `/scenario_view/${id}/${id_compare}`,
                state: {comparativa:comparativa}
            }) 
        }
    ];

    const calculateTabID = () => {
        switch(tabID) {
            case 1:
                return tabID
            case 2:
            case 3:
                return 2
            case 4:
                return 3
            case 5:
                return 4
            default:
                return tabID
        }
    }

    const fetchScenarioByTabID = async () => {
        try {
            setLoadingScenarioComparision(true)
            let body:ISimulationComparision = {
                id_scenario_base: id,
                id_scenario: id_compare,
                comparativa: comparativa,
                filters: {
                    month_from: dateFormatter(filters.month_from),
                    month_to: dateFormatter(filters.month_to),
                    own_foreign: filters.own_foreign,
                    transport: filters.transport,
                    warehouse: filters.warehouse
                },
                id_tab: calculateTabID()
            }
            const res = await getSimulationComparisionByTabID(body)
            
            if(res.status === 200) {
                const {code,data,message} = res.data
                if(code === 200) {
                    if(comparativa) {
                        setScenarioBase(data.scenario_base)
                        setScenarioComparision(data.scenario)
    
                        switch(tabID) {
                            case 1:
                                let primerArray = data.settings.entregas.series[0].data
                                let segundoArray = data.settings.entregas.series[1].data
                                                        // Comparar longitudes
                                if (primerArray.length > segundoArray.length) {
                                    while (segundoArray.length < primerArray.length) {
                                        segundoArray.push(0); // Agregar ceros al segundo array
                                    }
                                } else if (segundoArray.length > primerArray.length) {
                                    while (primerArray.length < segundoArray.length) {
                                        primerArray.push(0); // Agregar ceros al primer array
                                    }
                                }
                                if(filters.month_from === "" || filters.month_to === "") {
                                    
                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                        
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)
                                    setStateEntregas({options:{...stateEntregas.options,xaxis:{...stateEntregas.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.entregas.series[0].data,
                                            aux: data.settings.entregas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.entregas.series[1].data,
                                            aux: data.settings.entregas.series[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                    
                                    setStateEntregas({options:{...stateEntregas.options,xaxis:{...stateEntregas.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.entregas.series[0].data,
                                            aux: data.settings.entregas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.entregas.series[1].data,
                                            aux: data.settings.entregas.series[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                }
    
                                setKpisEntregas(data.settings.entregas.kpis.map((a:any,index:number) => ({title: index === 0? 'Entrada (Tm)' : index === 1? 'Nº Órdenes' : 'Coste (€)',kpiB: parseFloat(a.kpi_a).toFixed(2),kpiC: parseFloat(a.kpi_b).toFixed(2)})))
                                
                                emptyData()
    
                            break;
                            case 2:
                                setStateWarehouseRank({...stateWarehouseRank,series:[{
                                    name: 'Pajeras',
                                    data: data.settings.proveedores_internos[0].entradas.warehouse_rank[0].data
                                  }],options:{...stateWarehouseRank.options,legend:{...stateWarehouseRank.options.legend,customLegendItems:[data.scenario_base.name_scenario,data.scenario.name_scenario]}}})
    
                                  setStateNavesRank({...stateNavesRank,series:[{
                                    name: 'Naves',
                                    data: data.settings.proveedores_internos[0].entradas.naves_rank[0].data
                                  }],options:{...stateNavesRank.options,legend:{...stateNavesRank.options.legend,customLegendItems:[data.scenario_base.name_scenario,data.scenario.name_scenario]}}})
     
                                  if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                        
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)
                                    
                                    setStateInventario({options:{...stateInventario.options,chart:{...stateInventario.options.chart,events:{dataPointSelection: (event:any,chartContext:any,config:any) => testFunction(event,chartContext,config)}},xaxis:{...stateInventario.options.xaxis,categories:month_range},tooltip:{...stateInventario.options.tooltip,fixed:{...stateInventario.options.tooltip.fixed,offsetY:-30}}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[0].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[1].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                    

                                    

                                    
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    setStateInventario({options:{...stateInventario.options,chart:{...stateInventario.options.chart,events:{dataPointSelection: (event:any,chartContext:any,config:any) => testFunction(event,chartContext,config) }},xaxis:{...stateInventario.options.xaxis,categories:month_range},tooltip:{...stateInventario.options.tooltip,fixed:{...stateInventario.options.tooltip.fixed,offsetY:-30}}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[0].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[1].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})

                                    
                                    
                                }
                                
                                
                                setKpisEntradas(data.settings.proveedores_internos[0].entradas.kpis)
                                
                               
                                emptyData()
                            break;

                            case 3:
                                
                                  if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                        
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)
                                    
                                    
                                    

                                    setStateEntradasProveedorInterno({options:{...stateEntradasProveedorInterno.options,xaxis:{...stateEntradasProveedorInterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[0].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[1].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                          }
                                    ]})

                                    
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    

                                    setStateEntradasProveedorInterno({options:{...stateEntradasProveedorInterno.options,xaxis:{...stateEntradasProveedorInterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[0].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[1].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                    
                                }
                                
                                
                                setKpisSalidas(data.settings.proveedores_internos[1].salidas.kpis)
                                setStateDonutInternos({...stateDonutInternos,series:[data.settings.proveedores_internos[1].salidas.series_plot.series[0],data.settings.proveedores_internos[1].salidas.series_plot.series[1]],options:{...stateDonutInternos.options,aux:[data.settings.proveedores_internos[1].salidas.series_plot.aux[0],data.settings.proveedores_internos[1].salidas.series_plot.aux[1]],labels:[data.scenario_base.name_scenario,data.scenario.name_scenario]}})
                                
                                emptyData()
                            break;
    
                            case 4:
                                setKpisProveedoresExternos(data.settings.proveedores_externos.kpis)
                                //data.settings.proveedores_internos[1].salidas.series_plot.series
                                setStateDonutExternos({...stateDonutExternos,series:data.settings.proveedores_externos.series_plot.series,options:{...stateDonutExternos.options,aux:data.settings.proveedores_externos.series_plot.aux,labels:[data.scenario_base.name_scenario,data.scenario.name_scenario]}})
                                let primerArrayE = data.settings.proveedores_externos.series_entradas[0].data
                                let segundoArrayE = data.settings.proveedores_externos.series_entradas[1].data
                                                        // Comparar longitudes
                                if (primerArrayE.length > segundoArrayE.length) {
                                    while (segundoArrayE.length < primerArrayE.length) {
                                        segundoArrayE.push(0); // Agregar ceros al segundo array
                                    }
                                } else if (segundoArrayE.length > primerArrayE.length) {
                                    while (primerArrayE.length < segundoArrayE.length) {
                                        primerArrayE.push(0); // Agregar ceros al primer array
                                    }
                                }
                                if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                        
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)

                                    setStateEntradasProveedorExterno({options:{...stateEntradasProveedorExterno.options,xaxis:{...stateEntradasProveedorExterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_externos.series_entradas[0].data,
                                            aux : data.settings.proveedores_externos.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_externos.series_entradas[1].data,
                                            aux : data.settings.proveedores_externos.series_entradas[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    setStateEntradasProveedorExterno({options:{...stateEntradasProveedorExterno.options,xaxis:{...stateEntradasProveedorExterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_externos.series_entradas[0].data,
                                            aux : data.settings.proveedores_externos.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            data: data.settings.proveedores_externos.series_entradas[1].data,
                                            aux : data.settings.proveedores_externos.series_entradas[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                }
                                

                                emptyData()
                            break;
    
                            case 5:
                                let primerArrayC = data.settings.transporte.series_transporte[0].data
                                let segundoArrayC = data.settings.transporte.series_transporte[1].data
                                                        // Comparar longitudes
                                if (primerArrayC.length > segundoArrayC.length) {
                                    while (segundoArrayC.length < primerArrayC.length) {
                                        segundoArrayC.push(0); // Agregar ceros al segundo array
                                    }
                                } else if (segundoArrayC.length > primerArrayC.length) {
                                    while (primerArrayC.length < segundoArrayC.length) {
                                        primerArrayC.push(0); // Agregar ceros al primer array
                                    }
                                }
                                if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                        
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)

                                    setStateTransporte({options:{...stateTransporte.options,xaxis:{...stateTransporte.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: primerArrayC,
                                            aux : data.settings.transporte.series_transporte[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            //falta el 1 data y 1 aux
                                            data: segundoArrayC,
                                            aux : data.settings.transporte.series_transporte[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    setStateTransporte({options:{...stateTransporte.options,xaxis:{...stateTransporte.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: primerArrayC,
                                            aux : data.settings.transporte.series_transporte[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }, {
                                            name: data.scenario.name_scenario,
                                            //falta el 1 data y 1 aux
                                            data: segundoArrayC,
                                            aux : data.settings.transporte.series_transporte[1].aux,
                                            planned_date: data.scenario.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                }
                                
                                setKpisTransporte(data.settings.transporte.kpis)

                                emptyData()
                            break;
                        }

                    } else {
                        setScenarioBase(data.scenario_base)
                        setScenarioComparision(data.scenario)
    
                        switch(tabID) {
                            case 1:
                                if(filters.month_from === "" || filters.month_to === "") {
                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                    
                                    let from_year:any = data.scenario_base.campaign?.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base.campaign?.length === undefined? previous_year : data.scenario_base.campaign[1]
                                   
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)
                                    
                                    
                                    setStateEntregas({options:{...stateEntregas.options,xaxis:{...stateEntregas.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.entregas.series[0].data,
                                            aux: data.settings.entregas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                    
                                    
                                    setStateEntregas({options:{...stateEntregas.options,xaxis:{...stateEntregas.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.entregas.series[0].data,
                                            aux: data.settings.entregas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                }
                                
                                setKpisEntregas(data.settings.entregas.kpis.map((a:any,index:number) => ({title: index === 0? 'Entrada (Tm)' : index === 1? 'Nº Órdenes' : 'Coste (€)',kpiB: parseFloat(a.kpi_a).toFixed(2)})))
                                
                                emptyData()
    
                            break;
                            case 2:
                                setStateWarehouseRank({...stateWarehouseRank,series:data.settings.proveedores_internos[0].entradas.warehouse_rank,options:{...stateWarehouseRank.options,legend:{...stateWarehouseRank.options.legend,customLegendItems:[data.scenario_base.name_scenario]}}})
            
                                setStateNavesRank({...stateNavesRank,series: data.settings.proveedores_internos[0].entradas.naves_rank,options:{...stateNavesRank.options,legend:{...stateNavesRank.options.legend,customLegendItems:[data.scenario_base.name_scenario]}}})
                                
                                if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                    
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)

                                    setStateInventario({options:{...stateInventario.options,chart:{...stateInventario.options.chart,events:{dataPointSelection:  (event:any,chartContext:any,config:any) => testFunction(event,chartContext,config)}},xaxis:{...stateInventario.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[0].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }
                                    ]})

                                    
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    setStateInventario({options:{...stateInventario.options,chart:{...stateInventario.options.chart,events:{dataPointSelection: (event:any,chartContext:any,config:any) => testFunction(event,chartContext,config)}},xaxis:{...stateInventario.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[0].entradas.series[0].data,
                                            aux : data.settings.proveedores_internos[0].entradas.series[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }
                                    ]})

                                    
                                }
                                
                                
                                
                                setKpisEntradas(data.settings.proveedores_internos[0].entradas.kpis)
                                
                                
                                //en vez de [10,20] data.settings.proveedores_internos[1].salidas.series_plot.series
                                setStateDonutInternos({...stateDonutInternos,series:data.settings.proveedores_internos[1].salidas.series_plot.series,options:{...stateDonutInternos.options,aux:null,labels:data.settings.proveedores_internos[1].salidas.series_plot.labels }})
                                
                                emptyData()
                            break;
                            case 3:
                                
                                if(filters.month_from === "" || filters.month_to === "") {

                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                    
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)

                                    

                                    setStateEntradasProveedorInterno({options:{...stateEntradasProveedorInterno.options,xaxis:{...stateEntradasProveedorInterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[0].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    

                                    setStateEntradasProveedorInterno({options:{...stateEntradasProveedorInterno.options,xaxis:{...stateEntradasProveedorInterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.proveedores_internos[1].salidas.series_entradas[0].data,
                                            aux : data.settings.proveedores_internos[1].salidas.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                }
                                
                                
                                
                        
                                
                                setKpisSalidas(data.settings.proveedores_internos[1].salidas.kpis)
                                //en vez de [10,20] data.settings.proveedores_internos[1].salidas.series_plot.series
                                setStateDonutInternos({...stateDonutInternos,series:data.settings.proveedores_internos[1].salidas.series_plot.series,options:{...stateDonutInternos.options,aux:null,labels:data.settings.proveedores_internos[1].salidas.series_plot.labels }})
                                
                                emptyData()
                            break;
    
                            case 4:
                                setKpisProveedoresExternos(data.settings.proveedores_externos.kpis)

                                setStateDonutExternos({...stateDonutExternos,series:data.settings.proveedores_externos.series_plot.series,options:{...stateDonutExternos.options,aux:null,labels: data.settings.proveedores_externos.series_plot.labels}})
                                
                                if(filters.month_from === "" || filters.month_to === "") {
                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                    
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)
                                    
                                    setStateEntradasProveedorExterno({options:{...stateEntradasProveedorExterno.options,xaxis:{...stateEntradasProveedorExterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            //data.settings.proveedores_externos.series_entradas[0].data
                                            data: data.settings.proveedores_externos.series_entradas[0].data,
                                            aux : data.settings.proveedores_externos.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                
                                    setStateEntradasProveedorExterno({options:{...stateEntradasProveedorExterno.options,xaxis:{...stateEntradasProveedorExterno.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            //data.settings.proveedores_externos.series_entradas[0].data
                                            data: data.settings.proveedores_externos.series_entradas[0].data,
                                            aux : data.settings.proveedores_externos.series_entradas[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                        }
                                    ]})
                                }
                                

                                emptyData()
                            break;
    
                            case 5:
                        
                                if(filters.month_from === "" || filters.month_to === "") {
                                    let current_year:any = new Date().getFullYear() -1
                                    let previous_year = `${parseInt(current_year) - 1}`
                                    
                                    let from_year:any = data.scenario_base?.campaign.length === undefined? current_year : data.scenario_base.campaign[0]
                                    let to_year:any = data.scenario_base?.campaign.length === undefined? previous_year : data.scenario_base.campaign[1]
                                    
                                    let month_range = getMonthInterval(`08/${from_year}`,`07/${to_year}`)

                                    setStateTransporte({options:{...stateTransporte.options,xaxis:{...stateTransporte.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.transporte.series_transporte[0].data,
                                            aux : data.settings.transporte.series_transporte[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                } else {
                                    let month_range = getMonthInterval(dateFormatter(filters.month_from),dateFormatter(filters.month_to))
                                    
                                
                                    setStateTransporte({options:{...stateTransporte.options,xaxis:{...stateTransporte.options.xaxis,categories:month_range}},series:[
                                        {
                                            name: data.scenario_base.name_scenario,
                                            data: data.settings.transporte.series_transporte[0].data,
                                            aux : data.settings.transporte.series_transporte[0].aux,
                                            planned_date: data.scenario_base.planned_date ?? '09/01/2024'
                                          }
                                    ]})
                                }
                                
                                setKpisTransporte(data.settings.transporte.kpis.map((kpi:any) => ({...kpi,valueA:kpi.value})))

                                emptyData()
                            break;
                        }
                    }
                    setLoadingTab(false)

                    setLoadingScenarioComparision(false)       
                    
                } else if( code === 400) {
                    setLoadingTab(false)
                    warning(message)
                    setScenarioBase(INITIAL_STATE_SCENARIO)
                    setScenarioComparision(INITIAL_STATE_SCENARIO)
                    setStateEntregas(STATE_ENTREGAS_INITIAL_STATE)
                    setKpisEntregas([])
                    setLoadingScenarioComparision(false)
                } else {
                    setLoadingTab(false)
                    error(message)
                    setScenarioBase(INITIAL_STATE_SCENARIO)
                    setScenarioComparision(INITIAL_STATE_SCENARIO)
                    setStateEntregas(STATE_ENTREGAS_INITIAL_STATE)
                    setKpisEntregas([])
                    setLoadingScenarioComparision(false)
                }

                let aux = [0,0,0,0,0]
               

                if(filters.month_from !== "") {
                    aux[2] = 1
                }
                if(filters.month_to !== "") {
                    aux[2] = 1
                }
                if(filters.own_foreign !== "") {
                    aux[3] = 1
                }
                if(filters.transport.length > 0) {
                    aux[0] = 1
                }
                if(filters.warehouse.length > 0) {
                    aux[1] = 1
                }
                
                setFiltersUsedCounter(aux)
                setFiltersMASTER(filters)
            } else {
                setLoadingTab(false)
                setLoadingScenarioComparision(false)
                setScenarioBase(INITIAL_STATE_SCENARIO)
                setScenarioComparision(INITIAL_STATE_SCENARIO)
                setStateEntregas(STATE_ENTREGAS_INITIAL_STATE)
                setKpisEntregas([])
                error("Error obteniendo la información del escenario")
            }
            
        } catch(err:any) {
            console.log(err)
            setLoadingTab(false)
            catchResponse(err)
            setScenarioBase(INITIAL_STATE_SCENARIO)
            setScenarioComparision(INITIAL_STATE_SCENARIO)
            setStateEntregas(STATE_ENTREGAS_INITIAL_STATE)
            setKpisEntregas([])
            setLoadingScenarioComparision(false)
        }
    }


    const handleSwapScenarios = () => {
        
        let scenario_base = id
        let scenario_to_compare = id_compare
        
        history.push(`/scenario_plan/${scenario_to_compare}/${scenario_base}`)
    }

    const renderComparativaLoader = () => {
        switch(tabID) {
            case 1:
                return 'Obteniendo comparativa de entregas'
            case 2:
                return 'Obteniendo comparativa de los stocks iniciales'
            case 3:
                return 'Obteniendo comparativa de los proveedores internos'
            case 4:
                return 'Obteniendo comparativa de los proveedores externos'
            case 5:
                return 'Obteniendo comparativa del transporte'
            
        }
    }

    const renderNoComparativaLoader = () => {
        switch(tabID) {
            case 1:
                return 'Obteniendo la información de las entregas'
            case 2:
                return 'Obteniendo información de los stocks iniciales'
            case 3:
                return 'Obteniendo información de los proveedores internos'
            case 4:
                return 'Obteniendo información de los proveedores externos'
            case 5:
                return 'Obteniendo información del transportes'
            
        }
    }

   const ratioRenderer = (params:any) => {
    let {value} = params.data

    let total = 0
    currentTooltip.forEach((ct:any) => total += ct.value)

    return `${numberFormatter((value / total) * 100)} %`

   }

   const headerRenderer = () => {
    return (
        <div style={{fontFamily:'var(--roboto-medium)',color:'black',display:'flex' }}>
            Stock Inicial de Acopios (Tm) - {currentSerie.month}
        <div style={{minWidth:25,minHeight:5,backgroundColor:currentSerie.color,marginLeft:'1rem',borderRadius:50}}></div>    
        </div>
    )
   }


    const [filtersFlag, setFiltersFlag] = useState<boolean>(false)
    
    const fetchAllEscenarios = async() => {
        try {
            const res = await getAllScenarios()
            if(res.status === 200) {
                const { code, data } = res.data
                if( code === 200) {
                    setAllScenarios(data)
                } else {
                    setAllScenarios([])
                    error("No se pueden obtener los escenarios")
                }
            } else {
                setAllScenarios([])
                error("No se pueden obtener los escenarios")
            }
        } catch(err) {
            setAllScenarios([])
            error("No se pueden obtener los escenarios")
        }
    }

    useEffect(() => {
        fetchScenarioByTabID()
        fetchAllEscenarios()
    },[flagChangeScenario,id,id_compare, comparativa,filtersFlag])

    useEffect(() => {
        setLoadingTab(true)
        fetchScenarioByTabID()
    },[tabID,flagChangeScenario,id,id_compare,comparativa])

    
    const [inProp, setInProp] = useState(false);


    return (
        <div className="scenario_plan__wrapper">
            <Menu isOpen={inProp} tabID={tabID} entradas={entradas} comparativa={comparativa} onClick={() => setInProp(prev => !prev)} filtersUsedCounter={filtersUsedCounter} />
            <Dialog className="dialog-content-tooltip" header={headerRenderer} visible={visible} style={{ width: '65vw',height:'100vh'}} onHide={handleCloseTooltipModal}>
                <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'90%', width: '85%' }}>
                <AgGridReact
                    headerHeight={30}
                    getRowHeight={() => 30}
                    rowData={currentTooltip}
                    enableCellTextSelection>
                    <AgGridColumn filter sortable resizable={true} sort={'asc'} flex={1} headerName="Almacén"  field={"warehouse"}></AgGridColumn>
                    <AgGridColumn sortable filter  suppressNavigable={true}   headerName={"Tm"} cellRenderer={defaultRenderer} field={"value"}></AgGridColumn>
                    <AgGridColumn suppressNavigable={true} cellRenderer={ratioRenderer}  headerName={"(%) Ratio"} ></AgGridColumn>
                    
                </AgGridReact>
            </div>
            </Dialog>
            <div>
                <div className="scenario__header-name">
                    
                    <ScenarioSelector disabled={loadingScenarioComparision || loadingTab} allScenarios={allScenarios} scenarioToCompare={scenarioToCompare} setScenarioToCompare={setScenarioToCompare} setFlagChangeScenario={setFlagChangeScenario} flagChangeScenario={flagChangeScenario} title={`(${scenarioBase?.name_plant})`} color={'var(--lis-dark)'} base={true} simulation={true} />
                    <div className="scenario__header-input" >
                        <span className="p-inputgroup-addon" style={{backgroundColor:'var(--lis-dark)',color:'white'}}>
                            <HiOutlineIdentification style={{fontSize:20}} />
                        </span>
                        <InputText className="scenario-inputs" placeholder="Nombre de escenario" keyfilter="alphanum"  value={loadingScenarioComparision?"" : `${scenarioBase?.name_scenario}`} disabled />
                    </div>
                </div>

                {
                        comparativa?
                        <>
                        <FaExchangeAlt onClick={handleSwapScenarios} style={{minWidth:30,cursor:'pointer'}} />
                            <div className="scenario__header-name">
                                <ScenarioSelector disabled={loadingScenarioComparision ||loadingTab} allScenarios={allScenarios} scenarioBase={scenarioBase} scenarioToCompare={scenarioToCompare} setFlagChangeScenario={setFlagChangeScenario} flagChangeScenario={flagChangeScenario} title={`(${scenarioComparision?.name_plant})`} setScenarioToCompare={setScenarioToCompare} color={'var(--lis-alternative)'} base={false} loadingScenarioComparision={loadingScenarioComparision} simulation={true} />
                                    <div className="scenario__header-input" >
                                        <span className="p-inputgroup-addon"  style={{backgroundColor:'var(--lis-alternative)',color:'white'}}>
                                            <HiOutlineIdentification style={{fontSize:20}} />
                                        </span>
                                        
                                        <InputText  className="scenario-inputs" placeholder="Nombre de escenario" keyfilter="alphanum" value={loadingScenarioComparision?"" : `${scenarioComparision?.name_scenario}`} disabled />
                                        
                                    </div>
                                <span style={{cursor:'pointer'}} onClick={() => setComparativa(false)}>x</span>
                            </div>
                        </>
                        :
                            <>
                            <span style={{minWidth:30}}></span>
                            <div style={{minWidth:'35%'}}>
                                <span style={{fontFamily:'var(--roboto-medium)',fontSize:'0.85rem',cursor:'pointer',color:'gray'}} onClick={() => setComparativa(true)}> + Añadir simulación</span>
                            </div>
                            </>
                    }
                
                
                <div className="scenario__header-settings">
                    <Tooltip target=".speeddial-scenario .p-speeddial-action" position="bottom" style={{fontSize:'0.75rem'}} />
                    
                    <SpeedDial  className="speeddial-scenario" model={items} direction="left" transitionDelay={80} showIcon="pi pi-cog" hideIcon="pi pi-times" buttonClassName="p-button-outlined" />
                </div>
            </div>

            

            <div>
                
                <FiltersModal
                    idScenario={id}
                    campaign={scenarioBase.campaign}
                    visible={openFiltersModal}
                    setVisible={setOpenFiltersModal}
                    filters={filters}
                    setFilters={setFilters}
                    filtersMASTER={filtersMASTER}
                    filtersUsedCounter={filtersUsedCounter}
                    setFiltersUsedCounter={setFiltersUsedCounter}
                    filtersFlag={filtersFlag}
                    setFiltersFlag={setFiltersFlag}
                    />
                    
                
                <div className="card" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <TabView onClick={handleTabID} >
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <BsFillSendCheckFill size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Entregas'}})} />Entregas</span>}>
                            
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <MdInventory size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Stocks iniciales'}})} />Stocks iniciales</span>}>
                            
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <FcInternal size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Proveedores internos'}})} />Proveedores internos</span>}>
                            
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <FcExternal size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Proveedores externos'}})} />Proveedores externos</span>} >
                           
                        </TabPanel>
                        <TabPanel disabled={loadingTab} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <FaTruckMoving size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Transporte'}})} />Transporte</span>} >  
                           
                        </TabPanel>
                    </TabView>
                    {
                        filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0?
                            <div className="scenario_table_options-plan">
                                <i className="pi pi-filter p-overlay-badge pulse-anim" style={{ fontSize: '1rem',overflow:'initial' }}>
                                    <Badge style={{color:'black',overflow:'initial',paddingLeft:3}} value={filtersUsedCounter.filter((filt:any) => filt !== 0).length}></Badge>
                                </i>
                            </div>
                        :
                        false
                    }
            
                </div>
                
                {
                    
                    loadingScenarioComparision || loadingTab?
                            <div style={{height:'95%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                                {/*<Spinner message={comparativa?`Obteniendo comparativa de escenarios` : `Obteniendo información del escenario`}/>*/}
                                <FiCommand className="loading-icon" style={!comparativa? {fontSize:40,color:'var(--lis-dark)',opacity:0.6} : {fontSize:40,color:'var(--lis-alternative)',opacity:0.6}} />
                                    {comparativa?
                                        <span style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>{renderComparativaLoader()}</span>
                                        : 
                                        <span  style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>{renderNoComparativaLoader()}</span>
                                    }
                            </div>
                            
                        :
                        tabID === 1?
                            <EntregasLayout
                                comparativa={comparativa}
                                state={stateEntregas}
                                kpis={kpisEntregas}
                                fechaPlanificado={scenarioBase?.fecha_planificado}
                                filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                                />
                            :
                            tabID === 2?
                                <ProveedoresInternosLayout
                                    entradas={true}
                                    setEntradas={setEntradas} 
                                    comparativa={comparativa}
                                    stateWarehouseRank={stateWarehouseRank}
                                    stateNavesRank={stateNavesRank}
                                    escA={scenarioBase?.name_scenario}
                                    escB={scenarioComparision?.name_scenario}
                                    stateInventario={stateInventario}
                                    kpisEntradas={kpisEntradas}
                                    kpisSalidas={kpisSalidas}
                                    stateDonutInternos={stateDonutInternos}
                                    stateEntradasProveedorInterno={stateEntradasProveedorInterno}
                                    filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                                    />
                                :
                                tabID === 3?
                                    <ProveedoresInternosLayout
                                        entradas={false}
                                        setEntradas={setEntradas} 
                                        comparativa={comparativa}
                                        stateWarehouseRank={stateWarehouseRank}
                                        stateNavesRank={stateNavesRank}
                                        escA={scenarioBase?.name_scenario}
                                        escB={scenarioComparision?.name_scenario}
                                        stateInventario={stateInventario}
                                        kpisEntradas={kpisEntradas}
                                        kpisSalidas={kpisSalidas}
                                        stateDonutInternos={stateDonutInternos}
                                        stateEntradasProveedorInterno={stateEntradasProveedorInterno}
                                        filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                                        tabID={tabID}
                                        />
                                    : 
                                    tabID === 4?
                                        <ProveedoresExternosLayout
                                        comparativa={comparativa}
                                        kpisProveedoresExternos={kpisProveedoresExternos}
                                        stateDonutExternos={stateDonutExternos}
                                        stateEntradasProveedorExterno={stateEntradasProveedorExterno}
                                        filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                                        tabID={tabID}
                                        />
                                    :
                                    <TransporteLayout
                                        comparativa={comparativa} 
                                        kpisTransporte={kpisTransporte}
                                        stateTransporte={stateTransporte}
                                        filtered={filtersUsedCounter.filter((fuc:any) => fuc !== 0).length > 0}
                                        tabID={tabID}
                                        />
                }
               
            </div>
            
        </div>
    )
}